<ng-container *transloco="let t; read:'feature.news'">
    <div class="root" *ngIf="news$ | async as news">
        <div class="root__mobile-header">
            <a class="root__mobile-header__parent" routerLink="..">{{ t("backToNewsList") }}</a>
        </div>

        <div class="root__heading" [innerHTML]="news.heading.value"></div>

        <div class="root__header">
            <div class="root__header__heading" [innerHTML]="news.heading.value"></div>
        </div>

        <div class="root__date" [innerHTML]="news.startPublish | haDate:'dateTimeLongMonthWithYear'"></div>

        <div class="root__image" *ngIf="newsImage">
            <img [src]="newsImage" alt="News image" class="root__image__image" >
        </div>

        <xhtmlstring [data]="news.mainBody" class="root__text" [callerComponent]="'news'"></xhtmlstring>

        <div class="root__divider"></div>
        <a class="root__back" routerLink="..">{{ t("backToNewsList") }}</a>
    </div>
</ng-container>
